import peakMermaid from '../assets/peak-mermaid.svg';
import Icon from './Icon';

// Shared empty-state. Two moments, deliberately different weights:
//   • Genuinely empty ("nothing here yet") — the Peak mermaid illustration.
//     The brand gets room to show up; this is a welcome/getting-started moment.
//   • Filter matched nothing (`compact`) — a light magnifier + message. This is
//     a transient "adjust your filter" state, so it stays quiet, no ceremony.
// The mermaid lives here + in the login hero, not the navbar. Pass `children`
// for a richer body (e.g. a call-to-action button).
//
// `accent` is an optional small decoration positioned over the mermaid's
// corner (e.g. HeartIcon) — for a welcome moment that is also an invitation to
// take one specific action, not just "nothing here yet". Only meaningful
// alongside the mermaid; ignored in `compact` mode, which is a transient
// filter-miss state, not an invitation.
export default function EmptyState({ message, children, compact = false, className = '', accent }) {
  return (
    <div className={`empty-state${compact ? ' empty-state--compact' : ''}${className ? ' ' + className : ''}`}>
      {compact ? (
        <Icon name="search" size={34} className="empty-compact-icon" strokeWidth={1.6} />
      ) : (
        <span style={{ position: 'relative', display: 'inline-block' }}>
          <img src={peakMermaid} alt="" aria-hidden="true" className="empty-mermaid" />
          {accent}
        </span>
      )}
      {message && <p>{message}</p>}
      {children}
    </div>
  );
}
